module.exports = __webpack_public_path__ + "img/coins_1.a9e0bacd.png";